import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrganizationService } from '../../organization.service';

@Component({
  selector: 'app-edit-organization',
  templateUrl: './edit-organization.component.html',
  styleUrls: ['./edit-organization.component.scss']
})
export class EditOrganizationComponent implements OnInit {

  Form: FormGroup;
  countries: any;
  states: any;
  regions: any;
  country: any[] = [];
  state: any[] = [];
  region:any[] = [];

  constructor(
    private fb:FormBuilder,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditOrganizationComponent>,
    private organizationService: OrganizationService
  ) {
    const d = this.data;
    console.log(d);
    this.Form = this.fb.group
    ({
      name: [d && d.name?d.name:'',Validators.required],
      coutriesId: [d && d.coutriesId?d.coutriesId:'',Validators.required],
      stateIds: [d && d.stateIds?d.stateIds:'',Validators.required],
      regionIds: [d && d.regionIds?d.regionIds:'',Validators.required],
      description: [d && d.description?d.description:'',Validators.required],
      active: [d && d.active?d.active:true],

    });

  }

  ngOnInit(){
    this.getCountry();
    this.getState();
    this.getRegion();
  }

  get f(){
    return this.Form.controls;
  }

  async getCountry(){
    await this.organizationService.getCountry().subscribe(data => {
     if(data.length > 0){
      this.countries = data;
      console.log('countries',this.countries);
     }
     });



   }

   changeCountryId(id: string){
    console.log('val',id);
    this.countries.forEach((el: any) => {
      if(el.id === id){
        this.country.push({
          countryId: el.id,
          countryName: el.name
        })

      }
    });
    this.getState();
   }

   changeStateId(state: any){
    console.log('stateId',state);
    this.states.forEach((el1: any) => {
      state.forEach((el2: any) => {
        if(el1.id == el2){
          this.state.push({
            stateId: el1.id,
            stateName: el1.name
          })
        }
      });

    });
    this.getRegion();
   }

   changeRegionId(ids: any){
    this.regions.forEach((el1: any, i:any) => {
      ids.forEach((el2: any) => {
        if(el1.id == el2){
          this.region.push({
            regionId: el1.id,
            regionName: el1.name
          })
        }
      });

    });

    console.log('country',this.country);
    console.log('state',this.state);
    console.log('region',this.region);
   }

   getState(){
    let countryId = this.Form.value.coutriesId
    console.log('countryId',countryId);
    if(countryId){
       this.organizationService.getStates(countryId).subscribe(data => {
        if(data.length > 0){
         this.states = data;
         console.log('states',this.states);
        }
        });
    }
   }

   getRegion(){
    let countryId = this.Form.value.coutriesId;
    let stateIds = this.Form.value.stateIds;

    console.log('countryId',countryId);
    console.log('stateId',stateIds);
    stateIds.forEach((el: string) => {
      if(countryId){
         this.organizationService.getRegion(el).subscribe(data => {
         if(data.length > 0){
          this.regions = data;
          console.log('regions',this.regions);
         }
         });
     }
    });

   }


  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  async onSubmit(){
    this.spinner.show();
    console.log(this.Form.value);
    const orgData = {
       name: this.Form.value.name,
       description: this.Form.value.description,
       active: this.Form.value.active,
       coutriesId: this.Form.value.coutriesId,
       stateIds: this.Form.value.stateIds,
       regionIds: this.Form.value.regionIds,
       countries: this.country,
       states: this.state,
       regions: this.region
    }
    await this.organizationService.addEditOrganization(orgData,this.data?this.data.id: '' );
        this.dialogRef.close();
        this.spinner.hide();
    // this.http.addEditBlog(this.Form.value).subscribe((res)=>{
    //   if(res.success){
    //     this.dialog.open(SuccessComponent,{
    //       data:{
    //         title:"Updated!",
    //         subTitle:"Blog updated successfully."
    //       },
    //     });
    //     this.dialogRef.close();
    //   }
    //   this.spinner.hide();
    // },
    // err => {
    //   console.log('HTTP Error', err);
    //   this.spinner.hide();
    //   alert('Something went wrong,please try again');
    // },
    // )
  }

}
